import { render, staticRenderFns } from "./FormRegioes.vue?vue&type=template&id=8aec1a2c"
import script from "./FormRegioes.vue?vue&type=script&lang=js"
export * from "./FormRegioes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports